import { Flex } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/react";

function LoadingSkeleton() {
  return (
    <Flex flexDir="column" gridGap={4} px="16px" mt={4}>
      <Skeleton w="100%" h="80px" />
      <Skeleton w="100%" h="80px" />
      <Skeleton w="100%" h="80px" />
      <Skeleton w="100%" h="80px" />
      <Skeleton w="100%" h="80px" />
    </Flex>
  );
}

export default LoadingSkeleton;
